import { render, staticRenderFns } from "./BatchTransferPaginationBar.vue?vue&type=template&id=bbc1c08e"
import script from "./BatchTransferPaginationBar.vue?vue&type=script&lang=js"
export * from "./BatchTransferPaginationBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports